//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IBannedTermsClient {
    /**
     * Listar terminos prohibidos de busqueda
     * @param page (optional) Indice de pagina (inicia en 0)
     * @param size (optional) Cantidad de elementos por pagina
     * @param sort (optional) Orden
     */
    list(page?: number | undefined, size?: number | undefined, sort?: string | undefined): Observable<BannedTermsPageDto>;
    /**
     * Agregar terminos a la blacklist
     */
    add(body: AddBannedTermsDto): Observable<AddBannedTermsResponseDto>;
    /**
     * Eliminar un termino de la blacklist por id
     */
    remove(id: string): Observable<void>;
    /**
     * Eliminar un termino del indice ES de forma inmediata
     */
    removeIndexed(term: string): Observable<RemoveIndexedTermResponseDto>;
}

@Injectable({
    providedIn: 'root'
})
export class BannedTermsClient implements IBannedTermsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Listar terminos prohibidos de busqueda
     * @param page (optional) Indice de pagina (inicia en 0)
     * @param size (optional) Cantidad de elementos por pagina
     * @param sort (optional) Orden
     */
    list(page?: number | undefined, size?: number | undefined, sort?: string | undefined): Observable<BannedTermsPageDto> {
        let url_ = this.baseUrl + "/hub/search/banned-terms?";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new globalThis.Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BannedTermsPageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BannedTermsPageDto>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<BannedTermsPageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BannedTermsPageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token invalido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Agregar terminos a la blacklist
     */
    add(body: AddBannedTermsDto): Observable<AddBannedTermsResponseDto> {
        let url_ = this.baseUrl + "/hub/search/banned-terms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddBannedTermsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddBannedTermsResponseDto>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddBannedTermsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = AddBannedTermsResponseDto.fromJS(resultData202);
            return _observableOf(result202);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token invalido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Eliminar un termino de la blacklist por id
     */
    remove(id: string): Observable<void> {
        let url_ = this.baseUrl + "/hub/search/banned-terms/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token invalido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Eliminar un termino del indice ES de forma inmediata
     */
    removeIndexed(term: string): Observable<RemoveIndexedTermResponseDto> {
        let url_ = this.baseUrl + "/hub/search/banned-terms/indexed/{term}";
        if (term === undefined || term === null)
            throw new globalThis.Error("The parameter 'term' must be defined.");
        url_ = url_.replace("{term}", encodeURIComponent("" + term));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveIndexed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveIndexed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveIndexedTermResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveIndexedTermResponseDto>;
        }));
    }

    protected processRemoveIndexed(response: HttpResponseBase): Observable<RemoveIndexedTermResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RemoveIndexedTermResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("No autorizado / Token invalido", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class BannedTermsPageDto implements IBannedTermsPageDto {
    page!: PageDto;
    items!: BannedTermDto[];

    [key: string]: any;

    constructor(data?: IBannedTermsPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.page = new PageDto();
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.page = _data["page"] ? PageDto.fromJS(_data["page"]) : new PageDto();
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BannedTermDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BannedTermsPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new BannedTermsPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["page"] = this.page ? this.page.toJSON() : undefined as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBannedTermsPageDto {
    page: PageDto;
    items: BannedTermDto[];

    [key: string]: any;
}

export class AddBannedTermsDto implements IAddBannedTermsDto {
    /** Terminos a agregar a la blacklist */
    terms!: string[];

    [key: string]: any;

    constructor(data?: IAddBannedTermsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.terms = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["terms"])) {
                this.terms = [] as any;
                for (let item of _data["terms"])
                    this.terms!.push(item);
            }
        }
    }

    static fromJS(data: any): AddBannedTermsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddBannedTermsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.terms)) {
            data["terms"] = [];
            for (let item of this.terms)
                data["terms"].push(item);
        }
        return data;
    }
}

export interface IAddBannedTermsDto {
    /** Terminos a agregar a la blacklist */
    terms: string[];

    [key: string]: any;
}

export class AddBannedTermsResponseDto implements IAddBannedTermsResponseDto {
    added!: number;
    duplicates!: number;

    [key: string]: any;

    constructor(data?: IAddBannedTermsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.added = _data["added"];
            this.duplicates = _data["duplicates"];
        }
    }

    static fromJS(data: any): AddBannedTermsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddBannedTermsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["added"] = this.added;
        data["duplicates"] = this.duplicates;
        return data;
    }
}

export interface IAddBannedTermsResponseDto {
    added: number;
    duplicates: number;

    [key: string]: any;
}

export class RemoveIndexedTermResponseDto implements IRemoveIndexedTermResponseDto {
    term!: string;
    deletedFromSuggestions!: number;
    deletedFromTrending!: number;

    [key: string]: any;

    constructor(data?: IRemoveIndexedTermResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.term = _data["term"];
            this.deletedFromSuggestions = _data["deletedFromSuggestions"];
            this.deletedFromTrending = _data["deletedFromTrending"];
        }
    }

    static fromJS(data: any): RemoveIndexedTermResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveIndexedTermResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["term"] = this.term;
        data["deletedFromSuggestions"] = this.deletedFromSuggestions;
        data["deletedFromTrending"] = this.deletedFromTrending;
        return data;
    }
}

export interface IRemoveIndexedTermResponseDto {
    term: string;
    deletedFromSuggestions: number;
    deletedFromTrending: number;

    [key: string]: any;
}

export class PageDto implements IPageDto {
    /** Número de página (inicia en 0) */
    number!: number;
    /** Tamaño de página */
    size!: number;
    /** Total de elementos encontrados */
    totalElements!: number;
    /** Total de páginas */
    totalPages!: number;
    /** Indica si la página está vacía */
    empty!: boolean;

    [key: string]: any;

    constructor(data?: IPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            this.size = _data["size"];
            this.totalElements = _data["totalElements"];
            this.totalPages = _data["totalPages"];
            this.empty = _data["empty"];
        }
    }

    static fromJS(data: any): PageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        data["size"] = this.size;
        data["totalElements"] = this.totalElements;
        data["totalPages"] = this.totalPages;
        data["empty"] = this.empty;
        return data;
    }
}

export interface IPageDto {
    /** Número de página (inicia en 0) */
    number: number;
    /** Tamaño de página */
    size: number;
    /** Total de elementos encontrados */
    totalElements: number;
    /** Total de páginas */
    totalPages: number;
    /** Indica si la página está vacía */
    empty: boolean;

    [key: string]: any;
}

export class BannedTermDto implements IBannedTermDto {
    id!: string;
    term!: string;
    createdDate!: string;

    [key: string]: any;

    constructor(data?: IBannedTermDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.term = _data["term"];
            this.createdDate = _data["createdDate"];
        }
    }

    static fromJS(data: any): BannedTermDto {
        data = typeof data === 'object' ? data : {};
        let result = new BannedTermDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["term"] = this.term;
        data["createdDate"] = this.createdDate;
        return data;
    }
}

export interface IBannedTermDto {
    id: string;
    term: string;
    createdDate: string;

    [key: string]: any;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}